// V2 toast overlay. Fixed bottom-right stack. Click or X to dismiss.
// Rendered at the App root so it's available outside the auth gate and to
// portal views. Respects prefers-reduced-motion via CSS (see app.css).

import { useToastStore, type Toast } from '../lib/toastStore'

export default function Toasts() {
  const toasts = useToastStore((s) => s.toasts)
  const dismiss = useToastStore((s) => s.dismiss)

  if (toasts.length === 0) return null

  return (
    <div className="toast-stack" role="region" aria-label="Notifications" aria-live="polite">
      {toasts.map((t) => (
        <ToastItem key={t.id} toast={t} onDismiss={() => dismiss(t.id)} />
      ))}
    </div>
  )
}

function ToastItem({ toast, onDismiss }: { toast: Toast; onDismiss: () => void }) {
  return (
    <div
      className={`toast toast-${toast.type}`}
      role={toast.type === 'err' ? 'alert' : 'status'}
      onClick={onDismiss}
    >
      <span className="toast-msg">{toast.msg}</span>
      <button
        type="button"
        className="toast-close"
        aria-label="Dismiss"
        onClick={(e) => { e.stopPropagation(); onDismiss() }}
      >
        ✕
      </button>
    </div>
  )
}
